// extracted by mini-css-extract-plugin
module.exports = {"page":"dynamo-rail_page__1f6Wl","page__body":"dynamo-rail_page__body__hRi7r"};